<template>
  <div id="app" v-if="!['sHopErTynSaWw', 'dZpnOaCcAR'].includes(this.$route.path.split('/')[1])">
    <div id="headerHolder">
      <div id="header">
        <router-link to="/" exact><div id="logo">VND <span class="a1">diskont</span><span class="a2">namještaja</span></div></router-link>
        <div id="hamb" @click="menu = !menu"><img src="./assets/hamburger.png"/></div>
        <router-link to="/moji-artikli"><transition name="zooms" mode="out-in"><div id="korpa" :key="koms" v-if="isMobile">{{koms}}</div></transition></router-link>
        <div id="pretraga"><input v-if="jelte" autocomplete="off" :value="searchInput" @input='evt=>searchInput=evt.target.value' id="searchBox" ref="searchBox" placeholder="Unesite pretragu" @blur="jeste2()"  @focus="showSearch = true"> <img class="lupa" @click="jeste()" src="./assets/lupa.png" v-if="!jelte"/><div v-if="jelte" class="klk" id="clearSearch" @click="clearSearch">X</div></div>
        <div id="nav" :class="{ menuActive: menu }">
          <hr style="width:50%" v-if="isMobile">
          <div v-if="isMobile">
          <router-link to="/ponuda/akcija" class="akcija"><div>ARTIKLI NA AKCIJI</div></router-link>
          <router-link v-for="item in pndList" :key="item.kategorija_id" :to='"/ponuda/" + item.kategorija_url'><div>{{item.kategorija_naziv}}</div></router-link>
          </div>
          <hr style="width:50%" v-if="isMobile">
          <router-link to="/" exact ><div>Naslovna</div></router-link>
          <router-link to="/moji-artikli"><div>Moji artikli</div></router-link>
          <router-link to="/nacini-placanja"><div>Načini plaćanja</div></router-link>
          <router-link to="/kontakt"><div>Kontakt</div></router-link>
        </div>
      </div>
    </div>
    <div id="side_pnd" v-if="!isMobile">
       <router-link class="pnd_el akcija" to="/ponuda/akcija">ARTIKLI NA AKCIJI</router-link>
       <router-link class="pnd_el" v-for="item in pndList" :key="item.kategorija_id" :to='"/ponuda/" + item.kategorija_url'>{{item.kategorija_naziv}}</router-link>
    </div>

    <transition name="slide-left" v-if="!isMobile && this.$route.path !== '/'">
      <img src="./assets/banerd.jpg" id="banerd" v-if="majList.length === 0 || this.$route.path === '/moji-artikli'" />
      <div id="mojiArt" v-else>
        <router-link to="/moji-artikli"><div id="maHead">
          <div class="mah1">Moji Artikli</div>
          <div class="mah2">{{koms}} kom | {{zbirs}} €</div>
          <div class="mah3">ID: {{numid}}</div>
        </div></router-link>
        <div id="maList">
          <transition-group name="list-complete" tag="div">
            <div class="maItem" v-for="(item, index) in majList.slice().reverse()" :key="item.artikli_id">
              <router-link :to="'/ponuda/' + item.kategorija_url + '/' + item.artikli_id + '/' + item.podkat_url + '-' +  item.artikli_naziv.toLowerCase().replace(' ', '-')">
                <img :src="'/images/namjestaj/' + item.artikli_id + '/0.jpg'" :alt="item.artikli_naziv">
                <div class="naziv">{{item.artikli_naziv}}</div>
                <div class="cijena">{{item.artikli_kolicina}} x {{item.artikli_donjacijena.toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')}}€</div>
                <div class="aDiv" v-if="item.artikli_akcija==1">AKCIJA</div>
                <div class="remBtn klk" v-on:click.prevent="makni(majList.length - 1 - index)">-</div>
              </router-link>
            </div>
          </transition-group>
        </div>
        <router-link to="/moji-artikli"><div class="poruci">Poruči</div></router-link>
      </div>
    </transition>
    <div id="searchResult" v-bind:class="{ vidn: showSearch && searchInput !== '' && jelte }">
      <div v-if="filteredList.length === 0" style="width: 100%; text-align: center">Nije pronađeno ništa vezano za <strong>{{searchInput}}</strong></div>
      <div class="item" v-for="(item, index) in filteredList" :key="index">
        <router-link :to="'/ponuda/' + item.kategorija_url + '/' + item.artikli_id + '/' + item.podkat_url + '-' + item.artikli_naziv.toLowerCase().replace(' ', '-')">
          <img :src="'/images/namjestaj/' + item.artikli_id + '/0.jpg'" :alt="item.artikli_naziv">
          <div class="naziv">{{item.podkat_naziv}} {{item.artikli_naziv}}</div>
          <div id="cijena" class="nds" v-if="dalce === '0'">TRENUTNO<br>NEDOSTUPNO</div>
          <div class="cijena" v-else v-on:click.prevent="dodaj(index)">{{item.artikli_donjacijena}}€<div id="dodaj">+</div></div>
          <div class="aDiv" v-if="item.artikli_akcija==1">AKCIJA</div>
        </router-link>
      </div>
    </div>
       <router-view :key="$route.path"></router-view>
    <div id="footerHolder">
      <div id="footer">
        <div id="fleft"><strong>NAJPOVOLJNIJE!</strong> - PRVI ONLINE DISKONT NAMJEŠTAJA</div>
        <div id="fright">Info telefon: <strong>+382 (0) 67 626 673</strong> od 08h - 16h</div>
        <div id="pozovite"><a href="tel:0038267626673">Kliknite da nas pozovete (067 626 673)</a></div>
      </div>
    </div>
  </div>
  <div id="app" v-else>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>

import { db, auth } from './firebase/db'

// eslint-disable-next-line no-extend-native
String.prototype.includesOneOf = function (arrayOfStrings) {
  if (!Array.isArray(arrayOfStrings)) {
    throw new Error('includesOneOf only accepts an array')
  }
  return arrayOfStrings.some(str => this.toLowerCase().includes(str.toLowerCase()))
}

export default {
  data () {
    return {
      SiteInfo: {
        title: 'Namještaj najpovoljnije! VND online diskont.',
        image: 'https://vndnamjestaj.me/img/icons/og/vndnamjestaj.jpg',
        url: 'https://vndnamjestaj.me' + this.$route.path,
        description: 'Prvi online diskont namještaja u Crnoj Gori. Poručite namještaj jednostavno od kuće. Besplatna isporuka na teritoriji Crne Gore.'
      },
      menu: false,
      pndList: [],
      searchInput: '',
      searchList: [],
      aktivanDB: '',
      aktivan: false,
      showSearch: false,
      winwi: window.innerWidth,
      jelte: window.innerWidth > 600
    }
  },
  metaInfo () {
    return {
      title: this.SiteInfo.title,
      meta: [
        { name: 'description', content: this.SiteInfo.description },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'vndnamjestaj' },
        { property: 'og:title', content: this.SiteInfo.title },
        { property: 'og:image', content: this.SiteInfo.image },
        { property: 'og:url', content: this.SiteInfo.url }
      ]
    }
  },
  watch: {
    $route (to, from) {
      this.menu = false
      this.showSearch = false
      if (this.aktivan) {
        db.collection('korpe').doc(this.numid.toString()).update({
          oitem: to.path
        })
      }
    },
    majList () {
      if (this.aktivan) {
        db.collection('korpe').doc(this.numid.toString()).update({
          list: this.majList
        })
      }
    },
    aktivanDB () {
      this.aktivan = this.aktivanDB.broj.toString() === this.numid.toString()
      if (this.aktivan) {
        db.collection('korpe').doc(this.numid.toString()).update({
          list: this.majList
        })
      }
    }
  },
  created () {
    this.loadItems()
    this.loadAll()
    auth.onAuthStateChanged(user => {
      this.$store.dispatch('fetchUser', user)
    })
  },

  methods: {
    async loadItems () {
      const response = await fetch('https://vndnamjestaj.me/kaopnd.php')
      const data = await response.json()
      this.pndList = data
    },
    async loadAll () {
      const response = await fetch('https://vndnamjestaj.me/kaoitemlist.php')
      const data = await response.json()
      this.searchList = data
      this.searchList.forEach(element => {
        const nzv = element.artikli_naziv ? ',' + element.artikli_naziv.replace(' ', ',') : ''
        const dblj = element.dobavljac_naziv ? ',' + element.dobavljac_naziv.replace(' ', ',') : ''
        const konkat = element.kategorija_tagovi + ',' + element.podkat_tagovi + nzv + dblj
        element.tagovi = konkat.toLowerCase()
      })
    },
    makni (idx) {
      this.$store.dispatch('makniMoj', idx)
    },
    dodaj (id) {
      this.$store.dispatch('dodMoj', this.filteredList[id])
    },
    clearSearch () {
      if (this.isMobile) {
        this.$refs.searchBox.focus()
        if (this.searchInput === '') this.jelte = false
      }
      this.searchInput = ''
    },
    onResize () {
      this.winwi = window.innerWidth
    },
    jeste () {
      if (this.isMobile) {
        this.jelte = true
        this.menu = false
        this.$nextTick(() => {
          this.$refs.searchBox.focus()
        })
      }
    },
    jeste2 () {
      if (this.isMobile) {
        this.jelte = false
      }
    },
    leaving () {
      db.collection('korpe').doc(this.numid.toString()).delete()
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      window.addEventListener('pagehide', this.leaving)
    })
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    filteredList () {
      if (this.searchInput !== '') {
        var nizs = this.searchInput.toLowerCase().split(' ')
        return this.searchList.filter(post => {
          return nizs.every(v => post.tagovi.includes(v))
        })
      } else {
        return []
      }
    },
    majList () {
      return this.$store.getters.sMoj
    },
    zbirs () {
      if (this.majList.length > 0) {
        return this.majList.reduce(function (a, b) {
          return a + Number(b.artikli_donjacijena) * Number(b.artikli_kolicina)
        }, 0).toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')
      }
      return 0
    },
    koms () {
      return this.majList.reduce((a, b) => a + (b.artikli_kolicina || 0), 0)
    },
    numid () {
      return this.$store.getters.sId
    },
    isMobile () {
      return !(this.winwi > 601)
    }
  },
  firestore: {
    aktivanDB: db.collection('opcije').doc('aktivan')
  }
}
</script>

<style lang="scss">

@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";

#korpa{
    background-image: url('./assets/korpa.png');
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
    height: 37px;
    width: 25px;
    top: -18px;
    position: absolute;
    right: 54px;
    font-size: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 800;
}

.poruci{
  padding: 7px;
  background-color: #c00;
  color: #fff;
  cursor: pointer;
  border-radius: 0.6vw;
  font-weight: 900;
}

.poruci:hover{
  background-color: #a00;
}

[v-cloak] {
  display: none;
}

.klk{
  cursor: pointer;
  transition: all .2s ease-in-out;
}

.klk:active{
  transform: translateY(0.1vw) translateX(0.05vw);
    transition: .1s;
}

#clearSearch{
  border-radius: 2vw;
  background-color: #4a4b4c;
  color: #eee;
  width: 1.3vw;
  height: 1.3vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -0.15vw;
  right: 0.5vw;
  font-size: 0.7vw;
  font-weight: 400;
  cursor: pointer;
}

#clearSearch:hover{
  font-weight: 900;
}

*{
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: gray lightgray;
  font-size: 1vw;
}

h1{
  font-size: 1.6vw;
}

h2{
  font-size: 1.2vw;
}
.nds{
  font-size:0.8vw !important
}

@media only screen and (max-width: 600px) {
*{
  font-size: 5vw;
}
h1{
  font-size: 8vw;
}

h2{
  font-size: 6vw;
}
}
.nds{
  font-size:14px !important
}
*::-webkit-scrollbar {
  width: 3px;
}
*::-webkit-scrollbar-track {
  background: #d1dada;
}
*::-webkit-scrollbar-thumb {
  background-color:  #a8c1c2;
  border-radius: 20px;
  border: 0px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

html{
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

body{
  padding: 0px;
  margin: 0px;
  width: 100%;
  min-height: 100vh;
  overflow: auto;
  overflow-x: hidden;
}

#searchBox{
  border-radius: 1.1vw;
  width: 25vw;
  padding: 0.5vw 0.8vw;
  border: 1px solid #ccc;
  position: relative;
  top:-0.6vw;
  outline: none;
  font-size: 0.9vw;
}

#searchBox:focus{
  border: 1px solid #444;
  top:-0.6vw;
}

#searchResult{
  padding: 3.3vw 0.4vw 0vw;
  position: relative;
  z-index: 800;
  width: 68vw;
  background-color: #fff;
  margin: 0px auto;
  height: 100vh;
  top: -100vh;
  transition: top 0.5s;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  padding-bottom: 5vw;
  align-content: baseline;
}

/* Hide scrollbar for Chrome, Safari and Opera */
#searchResult::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
#searchResult{
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.vidn{
  top: 0px!important;
}

body{
  padding-bottom: 0px;
}

a {
  color: #000;
  text-decoration: none;
}

#app {
  font-family: 'Roboto Condensed', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#headerHolder{
  position: fixed;
  width: 100%;
  height: 3.4vw;
  padding: 1.2vw 0.6vw 0.6vw;
  z-index: 900;
  background-color: #fff;
  border-bottom: 0.1vw solid #f5f5f5;
  box-shadow: 0px 0px 15px 0px RGBA(0, 0, 0, 0.04);
}

#header{
  position: relative;
  width: 65.5vw;
  margin: 0px auto;
}

@media only screen and (max-width: 600px) {
  #searchResult{
    box-sizing: border-box;
    position: fixed;
    width: 100%;
    height: 100vh;
    overscroll-behavior: contain;
    padding: 56px 2px 180px;
  }
   #searchBox{
    border-radius: 30px;
    width: 82vw;
    padding: 10px;
    border: 1px solid #ccc;
    position: relative;
    top: -13px;
    outline: none;
    font-size: 16px;
    right: -9px;
  }
  #searchBox:focus{
    border: 1px solid #444;
    top: -13px;
  }
  .vidn{
    top: 0px!important;
  }
#clearSearch {
    border-radius: 50px;
    background-color: #4a4b4c;
    color: #eee;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -6px;
    right: -0.5vw;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
}
  body{
    padding-bottom: 0px;
  }
  #headerHolder{
    position: fixed;
    width: 100%;
    height: 48px;
    padding: 17px 10px 10px;
    z-index: 900;
    background-color: #fff;
    border-bottom: 0.1vw solid #f5f5f5;
    box-shadow: 0px 5px 9px 0px RGBA(0, 0, 0, 0.04);
  }

  #header{
    width: 100%;
  }
}

@supports (-webkit-touch-callout: none) {
   #searchBox{
    top: -15px;
  }
   #searchBox:focus{
    top: -15px;
  }
}

#logo{
  position: absolute;
  top: -0.7vw;
  font-weight: 900;
  font-size: 2.2vw;
}

#logo .a1{
  position: absolute;
  font-size: 0.76em;
  top: -0.5vw;
  font-weight: 100;
  color: #d00;
  transform: translateX(-0.1vw);
}

#logo .a2{
  font-size: 0.5em;
    font-weight: 700;
}

@media only screen and (max-width: 600px) {
  #logo{
    position: absolute;
    top: -5px;
    font-weight: 900;
    font-size: 22px;
    left:50%;
    transform: translateX(-50%);
  }
}

#nav{
  position: absolute;
  top: -0.6vw;
  right: 0px;
  a{
    box-sizing: border-box;
    padding: 0.6vw 1.2vw;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 1.2vw;
    transition: 0.4s;
    font-size: 0.92vw;
  }
  a.router-link-active, a.router-link-active:hover{
    background-color: #2e7274;
    color: white;
  }
  a:hover{
    background: #eef2f4;
    color: #000;
    transition: 0.1s;
  }
}

@media only screen and (max-width: 600px) {
  #nav{
    box-sizing: border-box;
    position: absolute;
    top: 30px;
    left: -10px;
    width: 100vw;
    height: 90vh;
    z-index: 900;
    background-color: #fff;
    transform: translateX(-100%);
    padding-top: 2vh;
    transition: transform 0.4s ease-in-out;
    overflow: auto;
    overflow-x: hidden;
    padding-bottom: 150px;
    overscroll-behavior: contain;
    a{
      box-sizing: border-box;
      padding: 7px 20px;
      display: block;
      align-items: center;
      justify-content: center;
      border-radius: 20px;
      transition: 0.4s;
      width: 70vw;
      margin: 1vh auto;
    }
    a.router-link-active, a.router-link-active:hover{
      background-color: #2e7274;
      color: white;
    }
    a.subs.router-link-active, a.subs:hover{
      width: 50vw;
    }
    a:hover{
      background: #eef2f4;
      color: #000;
    }
  }
}

.menuActive{
    transform: translateX(0%)!important;
    transition: 0.1s;
}

#hamb{
  display: none;
}

@media only screen and (max-width: 600px) {
  #hamb{
    display: block;
    position: absolute;
    left: 10px;
    img{
      height: 18px;
    }
  }
}

#pretraga{
  position: absolute;
  left: 12vw;
  top: 0.05vw;
}

@media only screen and (max-width: 600px) {
  #pretraga span{
    display: none;
  }
  #pretraga{
    right: 10px;
    left: inherit;
    top: 0px;
  }
}

.lupa{
  height: 1vw;
  position: absolute;
  right: 1vw;
}

@media only screen and (max-width: 600px) {
  .lupa{
    height: 17px;
  }
}

#footerHolder{
  position: fixed;
  width: 100vw;
  bottom: 0px;
  background: #0e5254;
  height: 2.5vw;
  box-sizing: border-box;
  padding: 0.6vw;
  color: #fff;
  z-index: 900;
}

@media only screen and (max-width: 600px) {
  #footerHolder{
    position: fixed;
    width: 100vw;
    bottom: 0px;
    background: #0e5254;
    height: 45px;
    box-sizing: border-box;
    padding: 13px 0px;
    color: #fff;
    z-index: 900;
  }
}

#footer{
  position: relative;
  width: 65.5vw;
  margin: 0px auto;
}

@media only screen and (max-width: 600px) {
  #footer{
    position: relative;
    width: 100vw;
    margin: 0px auto;
  }
}

#fleft{
  position: absolute;
  left:0px;
  top: 0.1vw;
  font-size: 1.1vw;
}

#fright{
  position: absolute;
  right:0px;
  font-size: 1.1vw;
}

@media only screen and (max-width: 600px) {
  #fleft, #fright{
    display: none;
  }
}

#pozovite{
  display: none;
}

@media only screen and (max-width: 600px) {
  #pozovite{
    display: block;
    a{
      color: #fff;
      font-size: 16px;
    }
  }
}

#side_pnd{
  position: fixed;
  z-index: 99999999;
  width: 12vw;
  max-height: 100%;
  text-align: left;
  top: 0px;
  left: 0px;
  padding-top: 3.4vw;
  overflow-y: auto;
  scrollbar-width: none;
  a{
    color: #eee;
    font-weight: 300;
    font-size: 1vw;
  }
}

#side_pnd::-webkit-scrollbar {
    width: 0px;
  }

.pnd_el{
  display: block;
  padding: 0.6vw 0.9vw;
  border-bottom: 0.1vw solid #1e6264;
  background-color: #2e7274;
}

.pnd_el:hover{
  background-color:#1e6264;
}

.akcija{
  background-color: #d00;
  font-weight: 800 !important;
  color: #fff;
}

.akcija:hover{
  background-color:#c00;
}

#banerd{
  position: absolute;
  right: 2vw;
  top: 5.5vw;
  z-index: 99999;
  height: 30vw;
  max-height: 70vh;
  border-radius: 0.6vw;
}

.item{
  width: 21.2vw;
  height: 13vw;
  background-color: #fff;
  position: relative;
  margin: 0.5vw 0.6vw;
  border-radius: 0.8vw;
  overflow: hidden;
  background-image: url('./assets/loading.gif');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 10%;
  img{
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0%;
    top: 0%;
    transition: height 0.2s, width 0.2s, left 0.2s, top 0.2s;
  }
  /*
  img:hover{
    height: 104%;
    width: 105%;
    left: -2%;
    top: -2.5%;
  }
  */
}

.naziv{
  position: absolute;
  bottom: 0.4vw;
  left: 0.5vw;
  font-weight: 400;
  color: #fff;
  text-shadow: 0.1vw 0.1vw 0.2vw RGBA(0, 0, 0, 1);
  font-size: 1vw;
}

@media only screen and (max-width: 600px) {
  .naziv{
    position: absolute;
    bottom: 1.4vw;
    left: 2.5vw;
    font-weight: 400;
    color: #fff;
    text-shadow: 0.2vw 0.2vw 0.8vw RGBA(0, 0, 0, 1);
    width: 60vw;
    text-align: left;
    font-size: 4vw;
    span {
      display: block;
    }
  }

.item {
    width: 46.2vw;
    height: 28.4vw;
    background-color: #fff;
    position: relative;
    margin: 1.6vw;
    border-radius: 0.8vw;
    overflow: hidden;
}

}

.cijena{
  position: absolute;
  z-index: 888;
  color: #000;
  background-color: #FD0;
  width: 5vw;
  height: 2.4vw;
  border-radius: 1.6vw 0px 0px 0px;
  bottom: -0.25vw;
  right: -0.1vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: 1.3vw;
  box-shadow: 0px 0px 0.6vw 0px RGBA(0, 0, 0, 0.3);
  transition: width 0.3s;
}

.cijena:hover{
  width: 6vw;
}

#dodaj{
  opacity: 0;
  position: absolute;
  background-color: #c00;
  border-radius: 30px;
  width: 1.4vw;
  height: 1.4vw;
  bottom: 1.2vw;
  left: -0.3vw;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0.05vw 0.05vw 0.2vw 0px RGBA(0,0,0,0.3);
  font-weight: 400;
  transition: opacity 0.3s;
}

.cijena:hover #dodaj{
  opacity: 1;
}

.aDiv{
  position: absolute;
  z-index: 888;
  color: #F00;
  width: 5vw;
  height: 2.3vw;
  top: -0.25vw;
  right: -0.1vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: 1vw;
  background-color: RGBA(254,254,254,0.9);
  border-radius: 0px 0px 0px 1.6vw;
}

@media only screen and (max-width: 600px) {
.cijena {
    position: absolute;
    z-index: 888;
    color: #000;
    background-color: #fd0;
    width: 10vw;
    height: 4.4vw;
    border-radius: 1.6vw 0 0 0;
    bottom: -.25vw;
    right: -.1vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 900;
    font-size: 3.3vw;
    box-shadow: 0 0 0.6vw 0 rgba(0,0,0,.3);
    transition: width .3s;
}
.aDiv {
    z-index: 888;
    color: red;
    width: 10vw;
    height: 4.3vw;
    top: -.25vw;
    right: -.1vw;
    font-weight: 900;
    background-color: hsla(0,0%,99.6%,.9);
    border-radius: 0 0 0 1.6vw;
}
}

.remBtn{
  width: 1.2vw;
  height: 1.2vw;
  position: absolute;
  right: 0px;
  bottom: 3vw;
  z-index: 99999;
  border-radius: 1.2vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #D00;
  color: #fff;
  font-size: 1vw;
  opacity: 0.3;
  transition: opacity 0.3s;
}

.remBtn:hover{
  opacity: 1;
}

.maItem{
  position: relative;
  width: 90%;
  margin: 0.2vw auto;
  border-radius: 0.5vw;
  font-size: 0.8vw;
  overflow: hidden;
  transition: all 0.5s;
}

.maItem .cijena{
  height: 1.3vw;
  font-size: 0.8vw;
  bottom: 0px;
  line-height: 1.7vw;
  border-radius: 1vw 0px 0px 0px;
  width: auto;
  padding: 0px 0.5vw;
}

.maItem .aDiv{
  width: 3.2vw;
  height: 1.5vw;
  font-size: 0.55vw;
  border-radius: 0px 0px 0px 1vw;
  top:0px;
}

#maList{
  overflow: hidden;
  overflow-y: auto;
  height: calc(100vh - 15.5vw);
}

.maItem img{
  width: 100%;
}

#mojiArt{
  position: fixed;
  right: 1vw;
  top: 3.3vw;
  width: 13vw;
  height: calc(96vh - 6vw);
  background-color: #eaebec;
  z-index: 300;
  font-size: 1.2vw;
}

#maHead{
  padding: 0.6vw;
}

.mah1{
  font-size: 1.3vw;
  font-weight: 700;
  margin: 1.4vw 0px 0.2vw;
}

.mah2{
  font-size: 1vw;
}

.mah3{
  font-size: 1vw;
}

.list-complete-enter, .list-complete-leave-to{
  opacity: 0;
  transform: translateX(-300px) translateY(-10px);
}
.list-complete-leave-active {
  transform: translateX(-300px);
  position: absolute;
}

.paging-enter, .paging-leave-to {
  opacity: 0;
}

.paging-enter-active, .paging-leave-active{
  transition: all 400ms
}

.slide-left-enter, .slide-left-leave-to {
  opacity: 0;
  transform: translateX(10vw)
}

.slide-left-enter-active, .slide-left-leave-active{
  transition: all 700ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.zooms-enter, .zooms-leave-to {
  font-size: 30px!important;
  color: #f00;
}

.zooms-enter-active, .zooms-leave-active{
  transition: all 300ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

</style>
